import { render, staticRenderFns } from "./PendingVideoconsultationItem.vue?vue&type=template&id=808513e8"
import script from "./PendingVideoconsultationItem.vue?vue&type=script&lang=js"
export * from "./PendingVideoconsultationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports